import { CognitoUser } from "amazon-cognito-identity-js"
import { Auth } from "aws-amplify"

class MfaFormController {
  /* @ngInject */

  /**
   * 
   * @param {*} $mdDialog 
   * @param {*} $mdToast 
   * @param {CognitoUser} cognitoUser 
   * @param {() => void} handleConfirmLogin
   */
  constructor ($scope ,$mdDialog, $mdToast, cognitoUser, handleConfirmLogin) {
    this.$scope = $scope
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.cognitoUser = cognitoUser
    this.verificationCode = ""
    this.handleConfirmLogin = handleConfirmLogin
  }
  
  /** 
   * @typedef {Object} CognitoMfaError
   * @property {String} name
   * @property {String?} message
   */

  showErrorModal (message) {
    this.$mdDialog.show(
      this.$mdDialog.alert()
        .parent(angular.element(document.querySelector('body')))
        .clickOutsideToClose(true)
        .title('Login Error')
        .textContent(message)
        .ariaLabel('Login Error')
        .ok('Login Page')
    )
  }

  async confirmLogin() {
    try {
      await Auth.confirmSignIn(this.cognitoUser, this.verificationCode.toString())
      this.handleConfirmLogin()
    } catch (/** @type {CognitoMfaError} */ e) {
      this.showErrorModal(e.message)
    }
  }

  closeDialog () {
    this.$mdDialog.cancel()
  }
}

export default MfaFormController
